module.exports = __webpack_public_path__ + "static/media/accept.eb3d6bdf.svg";